// find in store
const findStore = document.getElementById('js_find_store');
const storeEl = document.getElementById('js_store_el');
const productWishlist = document.querySelector('.js_product_wishlist');
const productSizes = document.getElementById('js_product_sizes');

if (findStore) {
  findStore.addEventListener('click', function () {
    storeEl.classList.add('active');
    productWishlist.classList.add('mt-s40');
    setTimeout(function () {
      window.scrollTo({
        top: storeEl.offsetTop - 300
        , behavior: 'smooth'
      });
    }, 100);
  });

  if (productSizes) {
    productSizes.addEventListener('click', function () {
      storeEl.classList.remove('active');
      productWishlist.classList.remove('mt-s40');
    })
  }
}